import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="alert"
export default class extends Controller {
  static targets = ["container"]

  dismiss() {
    this.containerTarget.style.transition = "opacity 0.3s ease-out"
    this.containerTarget.style.opacity = "0"
    
    setTimeout(() => {
      this.containerTarget.remove()
    }, 300)
  }
}
